import { useFireAIAnalyticsEvent } from '../utils';

// This is done to support mocking in tests
export const _useFireAIAnalyticsEvent = useFireAIAnalyticsEvent;